




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { ERecipientRole } from '@/dealroom/recipients/types/enums/recipient-role';
import FieldSettingsContainer from '@/dealroom/fields/context-menu/components/FieldSettingsContainer.vue';
import ConnectFieldContent from '@/dealroom/fields/components/ConnectFieldContent.vue';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import { IField } from '@/dealroom/fields/types/field';
import { IRecipient } from '@/types/Recipient';
import { IUser } from '@/types/User';
import { EFieldSource } from '@/api/fields/types/field-source';
import { FieldHelper } from '@/dealroom/fields/helpers/field.helper';

@Component({
  components: {
    FieldSettingsContainer,
    ConnectFieldContent,
  },
})
export default class FieldRecipients extends Vue {
  @Prop() fields: IField[];
  @Prop() sender!: IUser;
  @Prop({ default: () => [] }) recipients: IRecipient[];
  @Prop() height: string;
  @Prop() isTemplate: boolean;

  get filteredRecipients(): IRecipient[] {
    if (this.containsSignatureFields) {
      return this.recipients.filter(
        (recipient: IRecipient) => recipient.role === ERecipientRole.Signer
      );
    }
    return this.recipients;
  }

  get containsSignatureFields(): boolean {
    return this.fields.some((field: IField) =>
      [EFieldType.Signature, EFieldType.Initials].includes(field.type)
    );
  }

  get commonRecipientId(): string {
    const firstRecipientId: string = this.fields[0].recipientId;
    if (this.fields.every((field: IField) => field.recipientId === firstRecipientId)) {
      return firstRecipientId;
    }
    return null;
  }

  get connectToFirstRecipient(): boolean {
    return this.fields.every((field: IField) => field.isCollectable);
  }

  get allFieldsConnectedToSender(): boolean {
    return this.fields.every((field: IField) => field.source === EFieldSource.Sender);
  }

  handleSetSender(fields: IField[]): void {
    const mappedFields: IField[] = fields.map((field: IField) => ({
      ...field,
      recipient: null,
      recipientId: null,
      isCollectable: FieldHelper.isCollectable(null, field.type, field.value, false),
      source: EFieldSource.Sender,
      value: [EFieldType.Signature, EFieldType.Initials].includes(field.type)
        ? 'sender'
        : field.value,
    }));
    this.$emit('update', mappedFields);
  }

  handleSetRecipient(
    {
      recipient,
      connectFirstRecipient,
    }: {
      recipient: IRecipient;
      connectFirstRecipient: boolean;
    },
    fields: IField[]
  ): void {
    if (this.commonRecipientId && recipient && this.commonRecipientId === recipient.id) {
      return;
    }
    const mappedFields: IField[] = fields.map((field: IField) => ({
      ...field,
      recipientId: recipient ? recipient.id : null,
      recipient,
      sender: null,
      isCollectable: FieldHelper.isCollectable(
        recipient && recipient.id,
        field.type,
        field.value,
        connectFirstRecipient
      ),
      source: EFieldSource.Recipient,
      value: [EFieldType.Signature, EFieldType.Initials].includes(field.type)
        ? 'recipient'
        : field.value,
    }));
    this.$emit('update', mappedFields);
  }
}
